export default __webpack_public_path__ + "static/media/ico_chat_blue.de8742d5.svg";